/* Al-Haq "Complete the look": one-tap add for single-option pieces (e.g. kufis).
   Adds to cart, refreshes the cart drawer and cart count, then opens the drawer. */
if (!customElements.get('alhaq-quick-add')) {
  class AlhaqQuickAdd extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.add.bind(this));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.add(e);
        }
      });
    }
    add(e) {
      e.preventDefault();
      if (this.classList.contains('is-loading')) return;
      this.classList.add('is-loading');
      const formData = new FormData();
      formData.append('id', this.dataset.variantId);
      formData.append('quantity', 1);
      formData.append('sections', 'cart-drawer,cart-bubble');
      formData.append('sections_url', window.location.pathname);
      const root = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
      fetch(root, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) return;
          const parse = (html, sel) => {
            const el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
            return el ? el.innerHTML : null;
          };
          const drawer = document.getElementById('Cart-Drawer');
          if (drawer && res.sections && res.sections['cart-drawer']) {
            const target = drawer.querySelector('.cart-drawer') || drawer;
            const html = parse(res.sections['cart-drawer'], '.cart-drawer');
            if (html !== null) target.innerHTML = html;
          }
          const bubble = document.querySelector('#cart-drawer-toggle .thb-item-count');
          if (bubble && res.sections && res.sections['cart-bubble']) {
            const html = parse(res.sections['cart-bubble'], '.thb-item-count');
            if (html !== null) bubble.innerHTML = html;
          }
          if (drawer && typeof OverlayManager !== 'undefined') {
            OverlayManager.open(drawer);
          }
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res } }));
        })
        .catch((err) => console.error(err))
        .finally(() => this.classList.remove('is-loading'));
    }
  }
  customElements.define('alhaq-quick-add', AlhaqQuickAdd);
}
